import { MetalBracesPage } from "~/components/metal-braces/MetalBracesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/metal-braces")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/metal-braces"),
  component: MetalBracesPage,
});
